import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PfReport from "./Pf_report";
import EsiReport from "./Esi_report";

/**
 * Wraps the PF and ESI reports as tabs that toggle with state (like the
 * Overtime Report) — both stay mounted, so switching is instant with no
 * route change and no reload.
 */
const PfEsiReportTabs = () => {
  const [activeTab, setActiveTab] = useState("pf");

  return (
    <div className="container-fluid mt-4">
      <ToastContainer position="bottom-right" />

      {/* Tabs */}
      <div className="mb-3 d-flex flex-wrap" style={{ gap: "10px" }}>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "pf" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("pf")}
        >
          PF REPORT
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "esi" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("esi")}
        >
          ESI REPORT
        </button>
      </div>

      {/* Both stay mounted; only the active one is shown */}
      <div style={{ display: activeTab === "pf" ? "block" : "none" }}>
        <PfReport />
      </div>
      <div style={{ display: activeTab === "esi" ? "block" : "none" }}>
        <EsiReport />
      </div>
    </div>
  );
};

export default PfEsiReportTabs;
